<div class="bg-white rounded-lg p-6 shadow">
  <h3 class="text-xl font-semibold mb-4">Review Your Order</h3>

  <div class="mb-4">
    <div class="flex gap-2">
      @for (star of stars; track star) {
        <button
          (click)="setRating(star)"
          class="text-2xl focus:outline-none"
          [class.text-yellow-400]="star <= (rating ?? 0)"
          [class.text-gray-300]="star > (rating ?? 5)">
          ★
        </button>
      }
    </div>
  </div>

  <div class="mb-4">
    <textarea
      [(ngModel)]="comment"
      rows="4"
      class="w-full p-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
    placeholder="Share your experience with this order..."></textarea>
  </div>

  <button
    (click)="submitReview()"
    [disabled]="rating === 0 || isSubmitting"
    class="w-full bg-green-800 text-white py-2 rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
    @if (isSubmitting) {
      <span>Submitting...</span>
    }
    @if (!isSubmitting) {
      <span>Submit Review</span>
    }
  </button>
</div>
